import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface PublicSettings {
  platform_name?: string;
  platform_tagline?: string;
  platform_logo_url?: string;
  platform_mark_logo_url?: string;
  platform_favicon_url?: string;
  support_email?: string;
}

/**
 * Fetches public platform settings via edge function - works without auth.
 * Use this for branding on public pages (auth, landing, etc).
 */
export function usePublicPlatformSettings() {
  return useQuery({
    queryKey: ['public-platform-settings'],
    queryFn: async (): Promise<PublicSettings> => {
      const { data, error } = await supabase.functions.invoke('public-platform-settings');
      
      if (error) {
        console.warn('Failed to fetch public settings:', error);
        return {};
      }
      
      return data as PublicSettings;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 mins
    gcTime: 10 * 60 * 1000,
  });
}
